import React, { useEffect, useState } from "react";
import MsHome from "../../Components/Maruti-Suzuki-components/MsHome";
import BannerImage from "../../Components/login-components/banner-image/BannerImage";
import LogoContainer from "../../Components/login-components/logo-container/LogoContainer";
import BottomCard from "../../Components/login-components/bottom-card/BottomCard";
import CommonDropDown from "../../Components/global-components/CommonDropDown/CommonDropDown";
import TextInput from "../../Components/global-components/CommonTextInput/TextInput";
import { FormControl, IconButton, Button, FormControlLabel, MenuItem, Radio, RadioGroup, Select, TextField } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CommonButton from "../../Components/global-components/CommonButton/CommonButton";
import { useLocation, useNavigate } from "react-router-dom";
import { showGlobalError } from "../Redux/globalErrorSlice";
import { useDispatch, useSelector } from "react-redux";
import { useRef } from "react";
import { eddUploadDocument } from "../../services/edd-file-upload-service";

import axios from "axios";
import { FaFilePdf, FaTimes, FaTrash } from "react-icons/fa";
import { AddCircle, AddCircleOutlineTwoTone, Delete, IosShare, RemoveCircleOutlineTwoTone } from "@mui/icons-material";

const Trust_Edd = () => {
  const options = {
    industryOptions: [
      "Select",
      "Jewelry",
      "Import-Export",
      "Mining",
      "Shipping",
      "Scrap Dealing",
      "Real Estate",
      "Agriculture",
      "Stock Broking",
      "BFSI",
      "Manufacturing",
      "Other"
    ],
    option1: [
      "Select",
      "0-2.5 lacs",
      "2.5-5 lacs",
      "5-15 lacs",
      "15-20 lacs",
      "20-30 lacs",
      "30+ lacs",
    ],
    option2: [
      "Select",
      "Salaried",
      "Professional",
      "Self Employeed",
      "Student",
      "Home maker",
      "Other",
    ],
    option3: [
      "Select",
      "Government",
      "Private Limited",
      "Public Limited",
      "Trust",
      "Other",
    ],
    organisationType: [
      "Select",
      "Government",
      "Private Limited",
      "Public Limited",
      "Proprietor",
      "Partnership",
      "Trust",
      "HUF",
      "Section 25 Company",
      "Other"
    ],
    option4: ["Select", "Yes", "No", "Related to one"],
    proposerType: ["Select", "I", "C"],
    companyType: ["Select", "Private", "Public", "LLP", "Other"],
    categoryBusiness: ["Select", "Insurance", "Payments", "Lending"],
    citizenshipOption: ["Select", "Resident", "Non-Resident"],
    nationalityOption: ["Select", "Indian", "Other"],
    productTypesOption: ["Select", "Personal Loan", "Business Loan"],
    attachedFieldOptions: ["Select", "aadhaar", "drivingLicence", "passport", "voterid"]

  };
  const { state } = useLocation();
  const { kyc_Id, typeOfKyc } = state || {};
  const isExist = useSelector((state) => state.corporateSlice.isExist);
  // const kycTypeTab = useSelector((state) => state.Tabs.kycTypeTab);
  // const kycTypeTab = "Corporate";
  const Is_IDV3 = useSelector((state) => state.kycDetails.Is_IDV3);
  // const Is_IDV3 = true

  const companyType = useSelector((state) => state.corporateSlice.companyType);

  const { reason, panTypeError } = useSelector((state) => state.ExceptionReasonSlice);
  const {
    panNumber,
    permanentAddress,
    permanentCity,
    permanentState,
    permanentPincode,
    correspondenceAddressLineOne,
    correspondenceAddressLineTwo,
    correspondenceState,
    correspondenceCity,
    correspondencePincode,
  } = useSelector((state) => state.corporateSlice.userData);
  const kycId = useSelector((state) => state.corporateSlice.addNewKycId);
  const kycRefId = useSelector((state) => state.kycDetails.kycRefId);
  const CDDData = useSelector((state) => state.corporateSlice)

  const {
    isAryaLiteServiceUsed,
  } = useSelector((state) => state.corporateSlice.panUserdata);
  const { channelUrl, mi_u } = useSelector(
    (state) => state.partnerChannelNameSlice.marutiUserDetails
  );
  // const panNumber = useSelector((state) => state.panDetails.panNumber);

  const [isLoading, setIsLoading] = useState(false);
  // EDD Common Fields
  const [criminalProceedings, setCriminalProceedings] = useState("no");

  // Corporate Journey states
  const [hasPAT, setHasPAT] = useState("no"); // "yes" or "no"
  const [patFields, setPatFields] = useState([
    { key: "PAT_FY_1", value: "" },
  ]);
  const [solvencyRatio, setSolvencyRatio] = useState("");
  const [solvencyStatus, setSolvencyStatus] = useState("no");
  const [turnover, setTurnover] = useState("");
  const [turnoverStatus, setTurnoverStatus] = useState("no");
  const [yearsOfOperation, setYearsOfOperation] = useState("");
  const [shareholders, setShareholders] = useState([
    { Name: "", Shareholding_Percentage: "", External_Rating: "" },
  ]);
  const [kmpDirectors, setKmpDirectors] = useState([
    { Name: "", Designation: "" },
  ]);
  const [regulatoryActions, setRegulatoryActions] = useState("no");
  const [companyDebarred, setCompanyDebarred] = useState(false);

  const [hasAmlPolicy, setHasAmlPolicy] = useState(false);
  const [hasRiskManagementPolicy, setHasRiskManagementPolicy] = useState(false);

  const [compliesWithSanctionLaws, setCompliesWithSanctionLaws] = useState(true);
  const [sanctionComplianceDetails, setSanctionComplianceDetails] =
    useState("");
  console.log("sanctionComplianceDetails", sanctionComplianceDetails)
  // trust
  const [typeObjectTrust, setTypeObjectTrust] = useState("");
  const [registrationDate, setRegistrationDate] = useState("");
  const [trusteesDetails, setTrusteesDetails] = useState([
    { Name: "", Role: "" },
  ]);
  const [registrationPlace, setRegistrationPlace] = useState("");
  const [sourceOfFund, setSourceOfFund] = useState("");
  const [profitLossFY, setProfitLossFY] = useState([
    { Profit: "", Loss: "" },
  ]);
  // additional cdd fields in edd

  const [industryType, setIndustryType] = useState(CDDData.industryType);
  const [organisationType, setOrganisationType] = useState(options.organisationType.includes(companyType)? companyType : CDDData?.organisationType );
  // const [aadharNumber, setAadharNumber] = useState("");
  // const [voterIdNumber, setVoterIdNumber] = useState("");
  // const [drivingLicenceNumber, setDrivingLicenceNumber] = useState("");
  // const [passportNumber, setPassportNumber] = useState("");
  // const [existingKycNumber, setExistingKycNumber] = useState(kycId || "");
  const [political, setPolitical] = useState(CDDData.pep_flag ? "Yes" : "No");
  const [beneficialOwners, setBeneficialOwners] = useState("");
  const [beneficialOwnership, setBeneficialOwnership] = useState(CDDData.beneficialOwnership || false);
  const [beneficialOwnershipDetails, setBeneficialOwnershipDetails] = useState(CDDData.beneficialOwnershipDetails);
  const [selectedDocument, setSelectedDocument] = useState("");
  const [documentNumber, setDocumentNumber] = useState(CDDData.aadhaarNumber || CDDData.passportNumber || CDDData.drivingLicenceNumber || CDDData.voterIdNumber);
  const [aadhaarError, setAadhaarError] = useState("");
  const [errors, setErrors] = useState({
    industryType: '',
    organisationType: '',
    selectedDocument: '',
    documentNumber: "",
    existingKycNumber: '',
    pep_flag: '',
    beneficialOwnership: false,
    beneficialOwnershipDetails: '',
  });



  // file upload
  const inputRefs = useRef([]);
  const [fileNames, setFileNames] = useState([""]);
  const [uploadedUrls, setUploadedUrls] = useState([""]);
  const [fileUploadSuccess, setFileUploadSuccess] = useState(false)

  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    if (CDDData.aadhaarNumber) {
      setSelectedDocument("aadhaar")
    } else if (CDDData.passportNumber) {
      setSelectedDocument("passport")
    } else if (CDDData.drivingLicenceNumber) {
      setSelectedDocument("drivingLicence")
    } else if (CDDData.voteridNumber) {
      setSelectedDocument("voterid")
    }


  }, [CDDData])

 

  const handleFileUpload = async (index, e) => {
    const file = e.target.files[0];

    if (inputRefs.current[index]) {
      inputRefs.current[index].value = "";
    }

    if (!file) return;

    if (file.type !== "application/pdf") {
      return dispatch(showGlobalError("Only PDF format is allowed."));
    }

    if (file.size > 5 * 1024 * 1024) {
      return dispatch(showGlobalError("File exceeds 5MB size limit."));
    }

    // setIncomeProof(file.name);

    if (!kycRefId && !kycId) {
      alert("Please fill all required fields.");
      return;
    }

    const formData = new FormData();
    formData.append("income_proof", file);
    // formData.append("Pan_No", userPanNumber);
    formData.append("KYC_No", kycRefId || kycId);

    try {

      const response = await eddUploadDocument(formData);

      // const response = await axios.post(
      //     `${process.env.REACT_APP_BASE_URL}/primary/upload-edd`,
      //     formData,
      //     {
      //         headers: {
      //             "Content-Type": "multipart/form-data",
      //             // token: localStorage.getItem("token"),
      //             token:
      //                 localStorage.getItem("token")
      //         },
      //     }
      // );
      if (response?.success) {
        const uploadedUrl = response?.data?.income_proof;
        // setIncomeProofUrl(uploadedUrl);
        // console.log("Upload Success URL:", uploadedUrl);
        // alert("File uploaded successfully!");

        const newUrls = [...uploadedUrls];
        const newNames = [...fileNames];
        newUrls[index] = uploadedUrl;
        newNames[index] = file.name;

        setUploadedUrls(newUrls);
        setFileNames(newNames);

        setFileUploadSuccess(true)
        // alert("File uploaded successfully!");
        setTimeout(() => {
          setFileUploadSuccess(false)
        }, 3000)
      } else {
        dispatch(showGlobalError("Upload succeeded but no file URL returned."));
      }
    } catch (error) {
      setFileUploadSuccess(false)
      console.error("Upload Error:", error);
      dispatch(showGlobalError("File upload failed. Check console."));
    }
  };

  const handleAdd = () => {
    if (uploadedUrls.length < 3) {
      setUploadedUrls([...uploadedUrls, ""]);
      setFileNames([...fileNames, ""]);
    }
  };

  const handleDelete = (index) => {
    // If there's only one upload block, just clear it
    if (uploadedUrls.length === 1) {
      const newUrls = [...uploadedUrls];
      const newNames = [...fileNames];
      newUrls[0] = "";
      newNames[0] = "";
      setUploadedUrls(newUrls);
      setFileNames(newNames);

      // reset file input
      if (inputRefs.current[0]) {
        inputRefs.current[0].value = "";
      }
    } else {
      // If there are multiple upload blocks, remove the entire block
      const newUrls = [...uploadedUrls];
      const newNames = [...fileNames];
      newUrls.splice(index, 1);
      newNames.splice(index, 1);
      setUploadedUrls(newUrls);
      setFileNames(newNames);

      // Update refs array
      inputRefs.current.splice(index, 1);
    }
    setFileUploadSuccess(false);
  };
  const removeUploadBlock = (index) => {
    const newUrls = [...uploadedUrls];
    const newNames = [...fileNames];
    newUrls.splice(index, 1);
    newNames.splice(index, 1);
    setUploadedUrls(newUrls);
    setFileNames(newNames);
  };

  const formatFileName = (filename, maxBaseLength = 7) => {
    const dotIndex = filename.lastIndexOf(".");
    if (dotIndex === -1) return filename; // No extension
    const base = filename.slice(0, dotIndex);
    const ext = filename.slice(dotIndex); // includes the "."

    if (base.length > maxBaseLength) {
      return base.slice(0, maxBaseLength) + "..." + ext;
    }
    return filename;
  };

  const handleChangeShareHolders = (index, field, value) => {
    const updated = [...shareholders];
    updated[index][field] =
      field === "Shareholding_Percentage" ? parseFloat(value) || "" : value;
    setShareholders(updated);
  };

  const handleAddShareHolderRow = () => {
    if (shareholders.length < 5) {
      setShareholders([
        ...shareholders,
        { Name: "", Shareholding_Percentage: "", External_Rating: "" },
      ]);
    }
  };

  const handleRemoveShareHolderRow = (index) => {
    const updated = shareholders.filter((_, i) => i !== index);
    setShareholders(updated);
  };

  const handleAddKmpDirectorRow = () => {
    if (kmpDirectors.length < 5) {
      setKmpDirectors([...kmpDirectors, { Name: "", Designation: "" }]);
    }
  };


  const handleChangeKmpDirectors = (index, field, value) => {
    const updated = [...kmpDirectors];
    updated[index][field] = value;
    setKmpDirectors(updated);
  };


  const handleRemoveKmpDirectorRow = (index) => {
    const updated = kmpDirectors.filter((_, i) => i !== index);
    setKmpDirectors(updated);
  };

  const handleAddPATField = () => {
    if (patFields.length < 3) {
      const nextKey = `PAT_FY_${patFields.length + 1}`;
      setPatFields([...patFields, { key: nextKey, value: "" }]);
    }
  };

  const handleRemovePATField = (index) => {
    const updated = [...patFields];
    updated.splice(index, 1);
    setPatFields(updated);
  };

  const handleChangePAT = (index, newValue) => {
    const updated = [...patFields];
    updated[index].value = newValue;
    setPatFields(updated);
  };

  // trustees details
  const handleAddTrusteesDetailsRow = () => {
    if (trusteesDetails.length < 3) {
      setTrusteesDetails([...trusteesDetails, { Name: "", Role: "" }]);
    }
  };


  const handleChangeTrusteesDetails = (index, field, value) => {
    const updated = [...trusteesDetails];
    updated[index][field] = value;
    setTrusteesDetails(updated);
  };


  const handleRemoveTrusteesDetailsRow = (index) => {
    const updated = trusteesDetails.filter((_, i) => i !== index);
    setTrusteesDetails(updated);
  };

  function capitalizeFirstLetter(str) {
    if (typeof str !== 'string') {
      return str; // Return the input unchanged if it's not a string
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  let incomeFiles = {};
  const trust = {
    "KYC_No": kycId,
    "Is_IDV3": Is_IDV3,
    "Type_and_Object_of_Trust": typeObjectTrust,
    "Registration_Date": registrationDate,
    "Registration_Place": registrationPlace,
    "Trustees_Details": trusteesDetails,
    "PAT_FY_1": Number(patFields[0]?.value) || 0,
    "PAT_FY_2": Number(patFields[1]?.value) || 0,
    "PAT_FY_3": Number(patFields[2]?.value) || 0,
    "Solvency_Ratio": solvencyRatio === "" ? 0 : Number(solvencyRatio),
    "Turnover": turnover === "" ? 0 : Number(turnover),
    "Years_of_operation": yearsOfOperation === "" ? 0 : Number(yearsOfOperation),
    // "Beneficial_Owner": beneficialOwners,
        "Beneficial_Owners": beneficialOwnershipDetails,

    "Financial_Statements": incomeFiles,
    "Source_Of_Fund": sourceOfFund,
    "Has_AML_Policy": hasAmlPolicy,
    "Has_Risk_Management_Policy": hasRiskManagementPolicy,
    "Regulatory_Actions": regulatoryActions,
    "Criminal_Proceedings": criminalProceedings,
    "Company_Debarred": companyDebarred,
    "Complies_with_Sanction_Laws": compliesWithSanctionLaws,
    "Sanction_compliance_details": sanctionComplianceDetails,
  }


  let old_data = JSON.stringify({
    channel: channelUrl || "",
    txnId: mi_u || "",
    kyc_id: kyc_Id || kycId || "",
    pan_type_error: panTypeError || "",
    pan_reason: reason || "",
    permanentAddress: permanentAddress || "",
    permanentPincode: permanentPincode || "",
    permanentState: permanentState || "",
    permanentCity: permanentCity || "",
    correspondenceAddress: correspondenceAddressLineOne ? correspondenceAddressLineOne + correspondenceAddressLineTwo : permanentAddress,
    correspondenceCity: correspondenceCity || permanentCity || "",
    correspondencePincode: correspondencePincode || permanentPincode || "",
    correspondenceState: correspondenceState || permanentState || "",
    isAryaLiteServiceUsed,
    // cdd
    existingKycNumber: kycId || "",
    industryType: industryType,
    organisationType: organisationType,
    pep_flag: political === "Yes" || political === "Related to one" ? true : false,
    aadharNumber: selectedDocument === "aadhaar" ? documentNumber : "",
    passportNumber: selectedDocument === "passport" ? documentNumber : "",
    drivingLicenceNumber: selectedDocument === "drivingLicence" ? documentNumber : "",
    voterIdNumber: selectedDocument === "voterid" ? documentNumber : "",
    beneficialOwnership: beneficialOwnership,
    beneficialOwnershipDetails: beneficialOwnership ? beneficialOwnershipDetails : "",

  });
  const onClickHandler = async (e) => {
    e.preventDefault();
    let newErrors = {};
    let missingFields = [];


    // Check if ALL mandatory fields are empty (initial submit)
    // const allFieldsEmpty =
    // (isExist || !industryType ) &&
    // (isExist || !organisationType) &&
    // (isExist || !selectedDocument) &&
    // (isExist || !documentNumber) &&
    // (isExist || !political) && 
    // (isExist || (!beneficialOwnership || !beneficialOwnershipDetails));


    // if (allFieldsEmpty) {
    //   newErrors = {
    //     industryType: "Industry Type is required.",
    //     organisationType: "Organisation Type is required.",
    //     selectedDocument: "Document selection is required.",
    //     documentNumber: "Document number is required.",
    //     pep_flag: "PEP field is required.",
    //     beneficialOwnershipDetails:
    //       beneficialOwnership && !beneficialOwnershipDetails
    //         ? "Ownership details are required."
    //         : "",
    //   };


    //   // Collect field names for global popup
    //   missingFields = [
    //     "Industry Type",
    //     "Organisation Type",
    //     "Document selection",
    //     "Document number",
    //     "PEP field",
    //     "Beneficial Ownership Details",
    //   ];


    //   setErrors(newErrors);
    //   dispatch(
    //     showGlobalError(`Please fill these mandatory fields: ${missingFields.join(", ")}`)
    //   );
    //   console.log("Validation failed: All fields empty", newErrors);
    //   return;
    // }


    // INDIVIDUAL VALIDATION (one by one after first input filled)
    if (!isExist && !industryType) {
      newErrors.industryType = "Industry Type is required.";
    }

    if (!isExist && !organisationType) {
      newErrors.organisationType = "Organisation Type is required.";
    }

    if (!isExist && !selectedDocument) {
      newErrors.selectedDocument = "Document selection is required.";
    }

    if (!isExist && !documentNumber) {
      newErrors.documentNumber = "Document number is required.";
    } else {
      if(!isExist && documentNumber){
      switch (selectedDocument) {
        case "aadhaar":
          if (!/^\d+$/.test(documentNumber)) {
            newErrors.documentNumber = "Aadhaar must contain only numbers.";
          } else if (documentNumber.length !== 4) {
            newErrors.documentNumber = "Aadhaar must be exactly 4 digits.";
          }
          break;

        case "passport":
          if (!/^[A-Z]{1,2}[0-9]{2,39}$/.test(documentNumber)) {
            newErrors.documentNumber = "Invalid passport number format.";
          }
          break;

        case "voterid":
          if (documentNumber.length < 4 || documentNumber.length > 40) {
            newErrors.documentNumber =
              "Voter ID should be 4 to 40 characters.";
          }
          break;

        case "drivingLicence":
          if (!/^[A-Za-z0-9\/\-]{4,40}$/.test(documentNumber)) {
            newErrors.documentNumber = "Invalid Driving Licence format.";
          }
          break;

        default:
          if (documentNumber.length < 4 || documentNumber.length > 40) {
            newErrors.documentNumber =
              `${selectedDocument} must be 4 to 40 characters.`;
          }
          break;

      }
    }

    }


    if (!isExist && !political) {
      newErrors.pep_flag = "PEP field is required.";
    }


    if (beneficialOwnership && !beneficialOwnershipDetails) {
      newErrors.beneficialOwnershipDetails =
        "Ownership details are required when Beneficial Ownership is Yes.";
    }

    if (!compliesWithSanctionLaws && !sanctionComplianceDetails.trim()) {
      newErrors.beneficialOwnershipDetails = "Please specify which laws and regulations related to sanctions governance are applied where the entity is based?"
      // dispatch(
      //   showGlobalError(
      //     "Please specify which laws and regulations related to sanctions governance are applied where the entity is based?"
      //   )
      // );
      // return;
    }
    //  If no validation issue, proceed with submit


    // Set Errors
    setErrors(newErrors);


    // Show First Individual Error if Any
    if (Object.keys(newErrors).length > 0) {
      const firstErrorMsg = Object.values(newErrors)[0];
      dispatch(showGlobalError(firstErrorMsg));
      console.log("Validation failed:", newErrors);
      return;
    }

    try {
      uploadedUrls.forEach((url, i) => {
        if (url) incomeFiles[`income_${i + 1}`] = url;
      });




      const finalPayload = {
        existingKycNumber: kycId || "",
        industryType,
        organisationType,
        pep_flag: political === "Yes" || political === "Related to one" ? true : false,

        //     const attachedFieldOptions = [
        //   "aadhaar",  "drivingLicence", "passport", "voterid"
        // ];
        // doc any one
        aadharNumber: selectedDocument === "aadhaar" ? documentNumber : null,
        passportNumber: selectedDocument === "passport" ? documentNumber : null,
        drivingLicenceNumber: selectedDocument === "drivingLicence" ? documentNumber : null,
        voterIdNumber: selectedDocument === "voterid" ? documentNumber : null,

        // beneficial
        beneficialOwnership, // boolean
        beneficialOwnershipDetails: beneficialOwnership ? beneficialOwnershipDetails : "",

      };


      // 1. call the existing PATCH customer-meta API
      if (!isExist) {


        const configExistingDocument = {
          method: "patch",
          url: `${process.env.REACT_APP_BASE_URL}/customer/update-customer-meta?token=${localStorage.getItem("token")}`,
          headers: {
            "Content-Type": "application/json"
          },
          data: old_data,
        };
        const oldApiResponse = await axios(configExistingDocument);
                console.log("existing Corporate KYC PATCH Success", oldApiResponse.data);

      }
      // 2. Now call the new EDD POST API
      const eddCorpConfig = {
        method: "post",
        url: `${process.env.REACT_APP_BASE_URL}/primary/edd`,
        headers: {
          "Content-Type": "application/json",
        },
        data: trust,
        params: { token: localStorage.getItem("token") },
      };
      const eddResponse = await axios(eddCorpConfig);

      // 3. On full success, navigate to Success page
      navigate("/Success", {
        state: {
          kyc_ref_id: eddResponse?.data?.KYC_No,
        },
      });
    } catch (error) {
      console.error("Error in submission flow:", error);
      setIsLoading(false);
    }

    // let config = {
    //  method: "post",
    //  url: `${process.env.REACT_APP_BASE_URL}/primary/edd`,
    //  headers: {
    //    "Content-Type": "application/json",
    //  },
    //  data: corporate_final_data,
    //  params: { token: localStorage.getItem("token") }
    // };
    // axios(config)
    //  .then((response) => {
    //    console.log("KYC Submitted Successfully", response.data);
    //    navigate("/Success", {
    //      state: {
    //        kyc_ref_id: response?.data?.KYC_No,
    //      },
    //    });
    //  })
    //  .catch((error) => {
    //    console.error("Error in KYC submission:", error);
    //  });
  };

  return (
    <div>

      {/* Corporate Trust Journey */}
      <>
        {/* cdd fields starts */}
        <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2  gap-x-6 ">
        {!isExist  && <>
          <div className="w-full ">
            <CommonDropDown
              label="Organisation Type"
              options={options.organisationType}
              selected={organisationType}
              setSelected={setOrganisationType}
              AsteriskStar={true}
            />
          </div>
         
            <div className="w-full ">
            <CommonDropDown
              label="Industry Type"
              options={options.industryOptions}
              selected={industryType}
              setSelected={setIndustryType}
              AsteriskStar={true}
            />
          </div>
          </>}
        </div>
        <>
          {/* <div className="md:flex block mt-4 mb-4 md:gap-[17px]"> */}
          {!isExist  && <>
          <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-x-6 mt-4 gap-y-2">
            <CommonDropDown
              label="Select Documents"
              options={options.attachedFieldOptions}
              selected={selectedDocument}
              setSelected={setSelectedDocument}
              AsteriskStar={true}
            />


            <FormControl size="small" className="w-full flex gap-1">
              <div className="flex">
                <label className=" font-medium text-gray-900 md:mt-2 text-sm">
                  Document Identification Number
                  <span className="text-red-600">*</span>
                </label>
              </div>
              <TextField
                placeholder={capitalizeFirstLetter(selectedDocument) || "Enter document last 4 digit"}
                value={documentNumber}
                onChange={(e) => setDocumentNumber(e.target.value)}
                error={!!aadhaarError}
                helperText={aadhaarError}
                fullWidth
                size="small"
              />
            </FormControl>
          </div>
          </>}
        </>



        <div className="w-full mt-6">

          <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
            <p className="font-medium text-sm text-gray-900 mb-1 md:w-[50%]">
              Beneficial Ownership Details  <span className="text-red-600">*</span>
            </p>
            <RadioGroup
              row
              name="beneficial_ownership"
              value={beneficialOwnership ? "yes" : "no"}
              onChange={(e) => {
                if (e.target.value === "no") {
                  setBeneficialOwnership(false)
                } else {
                  setBeneficialOwnership(true)
                }
              }}
              className="w-[45%]"
            >
              <FormControlLabel value="yes" sx={{
                "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                {
                  color: "#E42125",
                },
                "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                  color: "#E42125",
                },
              }} control={<Radio />} label="Yes" />
              <FormControlLabel value="no" sx={{
                "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                {
                  color: "#E42125",
                },
                "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                  color: "#E42125",
                },
              }} control={<Radio />} label="No" />
            </RadioGroup>
          </div>
          {beneficialOwnership && (
            <>
              <div className="w-full mt-4">
                {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6"> */}
                <TextInput
                  fullWidth
                  size="small"
                  sx={{ marginTop: 1, marginBottom: 1 }}
                  // label="BeneficialOwnershipDetails"
                  placeholder="Enter the Beneficial Ownership Details "
                  id="beneficial_ownership_details"
                  value={beneficialOwnershipDetails}
                  onChange={(e) => setBeneficialOwnershipDetails(e.target.value)}
                />
              </div>
            </>
          )}
        </div>


        {/* cdd fields ends*/}

        <div className="w-full mt-6">
          <p className="text-sm font-bold text-gray-900 mb-1 w-[50%]">
            Key Metrics / Ratios:{" "}
            {/* <span className="text-red-600">*</span> */}
          </p>
          <div className="w-full mt-6">
            <div className="mt-5 mb-5">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
                <label htmlFor="hasPAT" className="text-sm font-medium text-gray-900 mb-1 md:w-[50%]">
                  1) PAT For last 3 FY:
                </label>
                <RadioGroup
                  row
                  name="hasPAT"
                  value={hasPAT}
                  onChange={(e) => {
                    const val = e.target.value;
                    setHasPAT(val);
                    if (val === "no") {
                      setPatFields([{ key: "PAT_FY_1", value: "" }]);
                    }
                  }}
                  className="w-[45%]"
                >
                  <FormControlLabel value="yes" sx={{
                    "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                    {
                      color: "#E42125",
                    },
                    "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                      color: "#E42125",
                    },
                  }} control={<Radio />} label="Yes" />
                  <FormControlLabel value="no" sx={{
                    "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                    {
                      color: "#E42125",
                    },
                    "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                      color: "#E42125",
                    },
                  }} control={<Radio />} label="No" />
                </RadioGroup>
              </div>
              {hasPAT === "yes" &&
                patFields.map((field, index) => (
                  <div
                    key={field.key}
                    className="flex flex-col md:flex-row items-start md:items-center gap-2 md:gap-4 mb-3"
                  >
                    <div className="w-full md:w-1/3">
                      <TextInput
                        id={field.key}
                        placeholder={`Enter ${field.key}`}
                        value={field.value}
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        onChange={(e) => {
                          const val = e.target.value;
                          if (/^\d*$/.test(val)) { // âœ… allows only 0-9, empty allowed
                            handleChangePAT(index, e.target.value)
                          }
                        }}
                      />
                    </div>

                    <div className="flex">
                      {index === patFields.length - 1 && patFields.length < 3 && (
                        <button
                          type="button"
                          onClick={handleAddPATField}
                          className=" text-red-500 px-3 py-1 rounded"
                        >
                          <AddCircleOutlineTwoTone />
                        </button>
                      )}
                      {patFields.length > 1 && (
                        <button
                          type="button"
                          onClick={() => handleRemovePATField(index)}
                          className=" text-red-500 px-3 py-1 rounded"
                        ><RemoveCircleOutlineTwoTone /></button>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </div>

          <div className="mt-5 mb-5">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
              <label htmlFor="solvencyRatio" className="text-sm font-medium text-gray-900 mb-1 md:w-[50%]">

                2) Solvency/ CRR/ Liquidity Ratio:

              </label>
              <RadioGroup
                row
                name="solvency"
                value={solvencyStatus}
                onChange={(e) => {
                  const value = e.target.value;
                  setSolvencyStatus(value);
                  if (value === "no") setSolvencyRatio(""); // reset if no
                }}
                className="w-[45%]"
              >
                <FormControlLabel value="yes" sx={{
                  "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                  {
                    color: "#E42125",
                  },
                  "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                    color: "#E42125",
                  },
                }} control={<Radio />} label="Yes" />
                <FormControlLabel value="no" sx={{
                  "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                  {
                    color: "#E42125",
                  },
                  "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                    color: "#E42125",
                  },
                }} control={<Radio />} label="No" />
              </RadioGroup>
            </div>
            {solvencyStatus === "yes" && (
              <TextInput
                type="text"
                placeholder="Enter solvency ratio"
                value={solvencyRatio}
                inputMode="numeric"
                pattern="[0-9]*"
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*$/.test(val)) {
                    setSolvencyRatio(e.target.value)
                  }
                }}
              />
            )}
          </div>

          <div className="mt-5 mb-5">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
              <label htmlFor="turnover" className="text-sm font-medium text-gray-900 mb-1 md:w-[50%]">
                3) Turnover:
              </label>
              <RadioGroup
                row
                name="key_metrics3"
                value={turnoverStatus}
                onChange={(e) => {
                  const value = e.target.value;
                  setTurnoverStatus(value);
                  if (value === "no") setTurnover(""); // reset if no
                }}
                className="w-[45%]"
              >
                <FormControlLabel value="yes" sx={{
                  "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                  {
                    color: "#E42125",
                  },
                  "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                    color: "#E42125",
                  },
                }} control={<Radio />} label="Yes" />
                <FormControlLabel value="no" sx={{
                  "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                  {
                    color: "#E42125",
                  },
                  "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                    color: "#E42125",
                  },
                }} control={<Radio />} label="No" />
              </RadioGroup>
            </div>

            {turnoverStatus === "yes" && (
              <>
                <TextInput
                  type="text"
                  placeholder="Enter turnover"
                  value={turnover}
                  inputMode="numeric"
                  pattern="[0-9]*"
                  onChange={(e) => {
                    const val = e.target.value;
                    if (/^\d*$/.test(val)) {
                      setTurnover(e.target.value)
                    }
                  }}
                />
              </>
            )}
          </div>
        </div>



        <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2  gap-x-6 ">

          <div className="w-full mt-6">
            <TextInput
              type="text"
              placeholder="Enter Years of Operation"
              label="Number of Years of Operation:"
              id="years_of_operation"
              inputMode="numeric"
              pattern="[0-9]*"
              onChange={(e) => {
                const val = e.target.value;
                if (/^\d*$/.test(val)) {
                  setYearsOfOperation(e.target.value)
                }
              }}
            />
          </div>
          <div className="w-full mt-6">
            <TextInput
              label="Type of Trust and object of the trust"
              placeholder="Enter details"
              id="type_and_object_trust"
              value={typeObjectTrust}
              onChange={(e) => setTypeObjectTrust(e.target.value)}
            />
          </div>
        </div>


                <div className="w-full mt-6">
          <div className="mt-5 mb-5">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
              <p className="text-sm font-medium text-gray-900 mb-1 md:w-[50%]">
                Details of regulatory / Other actions against the trust / trustees during the last 3 Years
                {/* <span className="text-red-600">*</span> */}
              </p>
              <RadioGroup
                row
                name="key_metrics2"
                value={regulatoryActions === "no" ? "no" : "yes"}
                onChange={(e) =>
                  e.target.value === "no"
                    ? setRegulatoryActions("no")
                    : setRegulatoryActions("")
                }
                className="w-[45%]"
              >
                <FormControlLabel value="yes" sx={{
                  "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                  {
                    color: "#E42125",
                  },
                  "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                    color: "#E42125",
                  },
                }} control={<Radio />} label="Yes" />
                <FormControlLabel value="no" sx={{
                  "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                  {
                    color: "#E42125",
                  },
                  "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                    color: "#E42125",
                  },
                }} control={<Radio />} label="No" />
              </RadioGroup>
            </div>
            {regulatoryActions !== "no" && (
              <TextInput
                placeholder="Enter Details"
                value={regulatoryActions}
                onChange={(e) => setRegulatoryActions(e.target.value)}
              />
            )}
          </div>
        </div>


        <div className="w-full mt-6">
          <div className="mt-5 mb-5">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
              <p className="text-sm font-medium text-gray-900 mb-1 md:w-[50%]">
               Details of criminal proceedings against the trust / trustees during the last 3 Years
                {/* <span className="text-red-600">*</span> */}
              </p>
              <RadioGroup
                row
                name="key_metrics1"
                value={criminalProceedings === "no" ? "no" : "yes"}
                onChange={(e) =>
                  e.target.value === "no"
                    ? setCriminalProceedings("no")
                    : setCriminalProceedings("")
                }
                className="w-[45%]"
              >
                <FormControlLabel
                  value="yes"
                  control={<Radio />}
                  sx={{
                    "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                    {
                      color: "#E42125",
                    },
                    "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                      color: "#E42125",
                    },
                  }}
                  label="Yes"
                />
                <FormControlLabel
                  sx={{
                    "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                    {
                      color: "#E42125",
                    },
                    "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                      color: "#E42125",
                    },
                  }}
                  value="no"
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </div>
            {criminalProceedings !== "no" && (

              <TextInput
                placeholder="Enter Details"
                value={criminalProceedings}
                onChange={(e) => setCriminalProceedings(e.target.value)}
              />
            )}
          </div>
        </div>

      

        <div className="w-full mt-6">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
            <p className="text-sm font-medium text-gray-900 mb-1 md:w-[50%]">
              Has the Company been debarred / blacklisted or reprimanded
              by any regulator / authority / govt. body in last 3 years:{" "}
              {/* <span className="text-red-600">*</span> */}
            </p>
            <RadioGroup
              row
              name="key_metrics3"
              value={companyDebarred ? "yes" : "no"}
              onChange={(e) => setCompanyDebarred(e.target.value === "yes")}
              className="w-[45%]"
            >
              <FormControlLabel
                value="yes"
                sx={{
                  "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                  {
                    color: "#E42125",
                  },
                  "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                    color: "#E42125",
                  },
                }}
                control={<Radio />}
                label="Yes"
              />
              <FormControlLabel
                value="no"
                sx={{
                  "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                  {
                    color: "#E42125",
                  },
                  "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                    color: "#E42125",
                  },
                }}
                control={<Radio />}
                label="No"
              />
            </RadioGroup>
          </div>
        </div>

        <div className="w-full mt-6">
          <p className="text-sm font-bold text-gray-900 mb-1 ">
            Does your Company have policies / framework on:{" "}
            {/* <span className="text-red-600">*</span> */}
          </p>
          <div className="mt-5 mb-5">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
              <p className="text-sm font-medium text-gray-900 mb-1 md:w-[50%]">
                1. Has the Company implemented an AML (Anti-Money Laundering) Policy?
                {/* <span className="text-red-600">*</span> */}
              </p>
              <RadioGroup
                row
                name="aml_policy"
                value={hasAmlPolicy ? "yes" : "no"}
                onChange={(e) => setHasAmlPolicy(e.target.value === "yes")}
                className="w-[45%]"
              >
                <FormControlLabel value="yes" sx={{
                  "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                  {
                    color: "#E42125",
                  },
                  "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                    color: "#E42125",
                  },
                }} control={<Radio />} label="Yes" />
                <FormControlLabel value="no" sx={{
                  "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                  {
                    color: "#E42125",
                  },
                  "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                    color: "#E42125",
                  },
                }} control={<Radio />} label="No" />
              </RadioGroup>
            </div>
          </div>

          <div className="mt-5 mb-5">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
              <p className="text-sm font-medium text-gray-900 mb-1 md:w-[50%]">
                2. Has the Company implemented a Risk Management Policy?
                {/* <span className="text-red-600">*</span> */}
              </p>
              <RadioGroup
                row
                name="risk_management_policy"
                value={hasRiskManagementPolicy ? "yes" : "no"}
                onChange={(e) => setHasRiskManagementPolicy(e.target.value === "yes")}
                className="w-[45%]"
              >
                <FormControlLabel value="yes" sx={{
                  "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                  {
                    color: "#E42125",
                  },
                  "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                    color: "#E42125",
                  },
                }} control={<Radio />} label="Yes" />
                <FormControlLabel value="no" sx={{
                  "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                  {
                    color: "#E42125",
                  },
                  "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                    color: "#E42125",
                  },
                }} control={<Radio />} label="No" />
              </RadioGroup>
            </div>
          </div>
        </div>




        <div className="w-full mt-6">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
            <p className="text-sm font-medium text-gray-900 mb-1 md:w-[50%]">
              {/* Does the Company comply with US/UK/EU/UN/local sanction laws? */}
              Are you required to comply with all applicable sanctions
              laws and regulations in accordance with United States
              (US), United Kingdom (UK), European Union (EU) or United
              Nations (UN) sanctions and any local laws and regulations
              where the entity is based? If No, please specify which
              laws and regulations related to sanctions governance are
              applied where the entity is based?
              {/* <span className="text-red-600">*</span> */}
            </p>
            <RadioGroup
              row
              name="sanction_laws"
              value={compliesWithSanctionLaws ? "yes" : "no"}
              onChange={(e) => {
                const isCompliant = e.target.value === "yes";
                setCompliesWithSanctionLaws(isCompliant);
                if (isCompliant) setSanctionComplianceDetails(""); // reset if 'yes'
              }}
              className="w-[45%]"
            >
              <FormControlLabel value="yes" sx={{
                "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                {
                  color: "#E42125",
                },
                "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                  color: "#E42125",
                },
              }} control={<Radio />} label="Yes" />
              <FormControlLabel value="no" sx={{
                "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                {
                  color: "#E42125",
                },
                "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                  color: "#E42125",
                },
              }} control={<Radio />} label="No" />
            </RadioGroup>
          </div>
          {!compliesWithSanctionLaws && (
            <TextInput
              placeholder="Enter sanction compliance details"
              value={sanctionComplianceDetails}
              onChange={(e) => setSanctionComplianceDetails(e.target.value)}
            />
          )}
        </div>



            <div className="w-full mt-4 md:mt-4">

                    <div className="flex justify-between items-start mb-1">

                      <div className="flex flex-col">

                        <label className="font-medium text-sm">

                       Financial Statements of last three FYs to be provided


                        </label>

                        <div className="text-xs text-[#5A5A5A] mt-1">

                          Allowed file size is 5 MB · Supported format: PDF

                        </div>

                      </div>

                    </div>



                    {/* File attachments container */}

                    <div className="flex flex-wrap gap-3 mb-3">

                      {uploadedUrls.map((url, index) => (

                        <div

                          key={index}

                          className="w-full md:w-[calc(33.333%-0.75rem)] transition-all duration-300"

                        >

                          {url ? (

                            // Uploaded file display

                            <div className="border flex justify-center py-2 border-green-200 bg-green-50 rounded-lg relative h-full">

                              <div className="flex items-center justify-center gap-2">

                                <div className="flex-shrink-0 text-red-600">

                                  <FaFilePdf size="16" />

                                </div>

                                <div className="min-w-0 flex-1">

                                  <p className="text-green-800 text-sm font-medium truncate">

                                    {fileNames[index] || `Document ${index + 1}`}

                                  </p>

                                </div>

                                {/* Show delete icon */}

                                <IconButton

                                  onClick={() => handleDelete(index)}

                                  color="error"

                                  size="small"

                                  className="flex-shrink-0 hover:bg-gray-50"

                                >

                                  <DeleteIcon fontSize="small" />

                                </IconButton>

                              </div>

                            </div>

                          ) : (

                            // Empty file input box

                            <div

                              className={`border-2 border-dashed rounded-lg p-2 transition-all duration-300 relative cursor-pointer border-gray-300 hover:border-gray-400`}

                              onClick={() => inputRefs.current[index]?.click()}

                            >

                              {/* Show delete (cross) icon for all except first box */}

                              {uploadedUrls.length > 1 && (

                                <IconButton

                                  onClick={(e) => {

                                    e.stopPropagation();

                                    handleDelete(index);

                                  }}

                                  color="error"

                                  size="small"

                                  className="absolute -top-2 -right-2 float-right hover:bg-gray-50 z-10 bg-white"

                                >

                                  <FaTimes size={14} />

                                </IconButton>

                              )}



                              <div className="flex items-center justify-center gap-2">

                                <div className="p-2 rounded-full bg-gray-100 text-gray-500">

                                  <FaFilePdf size={16} />

                                </div>

                                <div className="text-center">

                                  <p className="text-xs text-gray-500 mt-1">Click to upload</p>

                                </div>

                              </div>



                              <input

                                id={`pdf-upload-${index}`}

                                type="file"

                                accept="application/pdf"

                                hidden

                                ref={(ref) => (inputRefs.current[index] = ref)}

                                onChange={(e) => handleFileUpload(index, e)}

                              />

                            </div>

                          )}

                        </div>

                      ))}



                      {/* Automatically add next empty upload field after successful upload */}

                      {uploadedUrls.filter((url) => url).length === uploadedUrls.length &&

                        uploadedUrls.length < 3 && (

                          <div className="w-full md:w-[calc(33.333%-0.75rem)]">

                            <div

                              className="border-2 border-dashed rounded-lg p-2 transition-all duration-300 relative cursor-pointer border-gray-300 hover:border-gray-400"

                              onClick={() => inputRefs.current[uploadedUrls.length]?.click()}

                            >

                              <div className="flex items-center justify-center gap-2">

                                <div className="p-2 rounded-full bg-gray-100 text-gray-500">

                                  <FaFilePdf size={16} />

                                </div>

                                <div className="text-center">

                                  <p className="text-xs text-gray-500 mt-1">Click to upload</p>

                                </div>

                              </div>



                              <input

                                id={`pdf-upload-${uploadedUrls.length}`}

                                type="file"

                                accept="application/pdf"

                                hidden

                                ref={(ref) => (inputRefs.current[uploadedUrls.length] = ref)}

                                onChange={(e) => handleFileUpload(uploadedUrls.length, e)}

                              />

                            </div>

                          </div>

                        )}

                    </div>



                    {/* Success message */}

                    <div className="mt-2">

                      <p className="text-green-600 text-sm font-medium">

                        {fileUploadSuccess && "File uploaded successfully!"}

                      </p>

                    </div>

                  </div>
              






        {/* <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2  gap-x-6 "> */}

          <div className="w-full mt-4">
            <TextInput
              label="Source of Funds:"
              placeholder="Enter details"
              id="sourceoffund"
              value={sourceOfFund}
              onChange={(e) => setSourceOfFund(e.target.value)}
            />
          </div>
          {/* <div className="w-full mt-4">
            <TextInput
              fullWidth
              size="small"
              // sx={{ marginTop: 1, marginBottom: 1 }}
              // handleMargin="mt-2"
              label="Details of Beneficial Owners"
              placeholder="Enter Name"
              id="beneficial_owners"
              value={beneficialOwners}
              onChange={(e) => setBeneficialOwners(e.target.value)}
            />
          </div> */}
        {/* </div> */}

        {/* new code starts */}


        {/* <div className="flex w-full md:w-1/3"> */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6  gap-y-4 mt-4">
          <TextInput
            type="date"
            label="Registraion Date:"
            placeholder="Enter details"
            id="registration_date"
            value={registrationDate}
            onChange={(e) => setRegistrationDate(e.target.value)}
          />

          <TextInput
            label="Registration Place:"
            placeholder="Enter details"
            id="registration_place"
            value={registrationPlace}
            onChange={(e) => setRegistrationPlace(e.target.value)}
          />
        </div>


        <div className="w-full mt-6">
        </div>
        <div className="w-full mt-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Name and details of Trustees
          </label>
          {trusteesDetails.map((trustees, index) => (
            <div
              key={index}
              className="flex flex-col md:flex-row items-start md:items-center gap-2 md:gap-4 mb-3"
            >
              <div className="flex w-full md:w-1/3">
                <input
                  type="text"
                  placeholder="name"
                  value={trustees.Name}
                  onChange={(e) => handleChangeTrusteesDetails(index, "Name", e.target.value)}
                  className="border p-2 rounded w-full"
                />
              </div>
              <div className="flex w-full md:w-1/3">
                <input
                  type="text"
                  placeholder="role"
                  value={trustees.Role}
                  onChange={(e) => handleChangeTrusteesDetails(index, "Role", e.target.value)}
                  className="border p-2 rounded w-full"
                />
              </div>
              <div className="flex ">
                {index === trusteesDetails.length - 1 && trusteesDetails.length < 3 && (
                  <button
                    type="button"
                    onClick={handleAddTrusteesDetailsRow}
                    className=" text-red-600 px-3 py-1 rounded"
                  >
                    <AddCircleOutlineTwoTone />
                  </button>
                )}
                {trusteesDetails.length > 1 && (
                  <button
                    type="button"
                    onClick={() => handleRemoveTrusteesDetailsRow(index)}
                    className=" text-red-600 px-3 py-1 rounded"
                  >
                    <RemoveCircleOutlineTwoTone />
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        {!isExist  && <>
        <div className="w-full mt-4">
          <CommonDropDown
            options={options.option4}
            selected={political}
            setSelected={setPolitical}
            label={"Are you a Politically Exposed Person(PEP) or family member/ close relative / associate of PEP"}
            AsteriskStar={true}
            labelSize="small"
          />
          {/* <p className="text-red-500 text-sm" id="incomeError">
                                                    {error && error}
                                                  </p> */}
          <i className="text-[10px] font-medium text-black">
            "Politically Exposed Persons" (PEPs) are individuals who have been entrusted with prominent public functions by a foreign country, including the heads of States or Governments, senior politicians, senior government or judicial or military officers, senior executives of state-owned corporations and important political party officials.
          </i>

        </div>
        </>}

        {/* new code ends */}
        <div className="w-full mt-7 md:w-[15%] mb-3 flex justify-center">
          <CommonButton
            center
            label="Submit"
            filled
            onClickHandler={onClickHandler}
          />
        </div>
      </>

    </div >
  );
};

export default Trust_Edd;